import { produce } from 'immer';
import { DashboardModel, DashboardWidgetUnion } from '../types';

interface Params {
  widget: DashboardWidgetUnion;
}

export const updateDashboardWidget = ({ widget }: Params) =>
  produce((dashboard: DashboardModel) => {
    if (dashboard.layout) {
      const idx = dashboard.layout.findIndex(({ id }) => id === widget.id);
      dashboard.layout[idx] = widget;
    }
  });
